/**
 * Simple date formatting utilities to replace date-fns
 */

export const format = (date, formatString) => {
  const d = new Date(date);
  
  if (isNaN(d.getTime())) {
    return 'Invalid Date';
  }

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const day = d.getDate().toString().padStart(2, '0');
  const month = months[d.getMonth()];
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');

  // Handle common format patterns
  switch (formatString) {
    case 'MMM dd, yyyy • HH:mm':
      return `${month} ${day}, ${year} • ${hours}:${minutes}`;
    case 'HH:mm':
      return `${hours}:${minutes}`;
    case 'MMM dd, yyyy':
      return `${month} ${day}, ${year}`;
    case 'yyyy-MM-dd':
      return `${year}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${day}`;
    default:
      return d.toLocaleDateString();
  }
};

export const isAfter = (date1, date2) => {
  return new Date(date1) > new Date(date2);
};

export const isBefore = (date1, date2) => {
  return new Date(date1) < new Date(date2);
};

export const isToday = (date) => {
  const today = new Date();
  const checkDate = new Date(date);
  
  return checkDate.toDateString() === today.toDateString();
};

export const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const formatRelativeTime = (date) => {
  const now = new Date();
  const inputDate = new Date(date);
  const diffInMs = inputDate - now;
  const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
  
  if (diffInDays === 0) {
    return 'Today';
  } else if (diffInDays === 1) {
    return 'Tomorrow';
  } else if (diffInDays === -1) {
    return 'Yesterday';
  } else if (diffInDays > 1) {
    return `In ${diffInDays} days`;
  } else {
    return `${Math.abs(diffInDays)} days ago`;
  }
}; 